import React from 'react';
import { Image as ChakraImage, ImageProps as ChakraImageProps } from '@chakra-ui/react';

export function Image(props: ChakraImageProps) {
  return <ChakraImage {...props} />;
}
